import {
  IconMetroEkb16,
  IconMetroKzn16,
  IconMetroMsk16,
  IconMetroNN16,
  IconMetroNovosib16,
  IconMetroSam16,
  IconMetroSpb16,
} from '@cian/ui-kit';

import { type FC, useMemo } from 'react';

import styles from './UndergroundIcon.css';

export interface IUndergroundIconProps {
  color: string;
  regionId?: number;
}

/* Старый компонент кружочка метро, взятый из серпа. Требуется рефакторинг */

export const UndergroundIcon: FC<IUndergroundIconProps> = ({ color, regionId }) => {
  const icon: React.ReactNode = useMemo(() => {
    switch (regionId) {
      case -1: // Москва и область
      case 1: // Москва
      case 4593: // Московская область
        return <IconMetroMsk16 color="current_color" />;

      case -2: // СПб и область
      case 2: // СПб
      case 4588: // Ленинградская область
        return <IconMetroSpb16 color="current_color" />;
      case 4743: // Екатеринбург
        return <IconMetroEkb16 color="current_color" />;
      case 4777: // Казань
        return <IconMetroKzn16 color="current_color" />;
      case 4897: // Новосибирск
        return <IconMetroNovosib16 color="current_color" />;
      case 4966: // Самара
        return <IconMetroSam16 color="current_color" />;

      case 4885: // Нижний Новгород
        return <IconMetroNN16 color="current_color" />;
      default:
        return (
          // eslint-disable-next-line react/forbid-elements
          <svg height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="8" fill="currentColor" r="8" />;
          </svg>
        );
    }
  }, [regionId]);

  return (
    <div className={styles['icon']} style={{ color, display: 'flex' }}>
      {icon}
    </div>
  );
};
